module.exports = __webpack_public_path__ + "static/media/030.45705e62.jpg";